import { render, staticRenderFns } from "./LastModified.vue?vue&type=template&id=6a4f4b1d&"
import script from "./LastModified.vue?vue&type=script&lang=js&"
export * from "./LastModified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports